import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { binderService } from '../services/binderService';
import { Binder } from '../types';

export function useBinders() {
  return useQuery({ queryKey: ['binders'], queryFn: binderService.list });
}

export function useBinder(id: number) {
  return useQuery({
    queryKey: ['binders', id],
    queryFn: () => binderService.getById(id),
    enabled: !!id,
  });
}

export function useCreateBinder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Binder>) => binderService.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['binders'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useUpdateBinder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Binder> }) => binderService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['binders'] }),
  });
}

export function useDeleteBinder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => binderService.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['binders'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useAddCardsToBinder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ binderId, cardIds }: { binderId: number; cardIds: number[] }) =>
      binderService.addCards(binderId, cardIds),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['binders'] }),
  });
}

export function useRemoveCardFromBinder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ binderId, cardId }: { binderId: number; cardId: number }) =>
      binderService.removeCard(binderId, cardId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['binders'] }),
  });
}
